Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AtlasEnv () {
        return AtlasEnv;
    },
    get envFromHostname () {
        return envFromHostname;
    },
    get envFromString () {
        return envFromString;
    }
});
const AtlasEnv = Object.freeze({
    dev: 'dev',
    test: 'test',
    ote: 'ote',
    stg: 'stg',
    prod: 'prod'
});
function envFromString(env) {
    // Handle sub-environments
    const baseEnv = env.split('.')[0].toLowerCase();
    switch(baseEnv){
        case 'development':
        case 'dev':
        case 'dev-private':
        case 'local':
            return AtlasEnv.dev;
        case 'testing':
        case 'test':
            return AtlasEnv.test;
        case 'production':
        case 'prod':
            return AtlasEnv.prod;
        case 'stg':
        case 'stage':
        case 'staging':
            return AtlasEnv.stg;
        case 'ote':
            return AtlasEnv.ote;
        default:
            throw new Error('Invalid environment. Must be one of: dev, test, stg, ote, prod');
    }
}
const envMap = [
    [
        /(dev-)/i,
        AtlasEnv.dev
    ],
    [
        /test-/i,
        AtlasEnv.test
    ],
    [
        /ote-/i,
        AtlasEnv.ote
    ],
    [
        /stg-/i,
        AtlasEnv.stg
    ],
    [
        /(^localhost$)/i,
        AtlasEnv.dev
    ]
];
function envFromHostname(hostname) {
    for (const [pattern, env] of envMap){
        if (pattern.test(hostname)) {
            return env;
        }
    }
    return AtlasEnv.prod;
}
